<tax-page-header titleText="Страница с инпутами"></tax-page-header>

<div class="ui-kit-content-container ui-kit-column-flex">
  <tax-phone-input [(ngModel)]="phoneModel" [required]="true" [layoutColumns]="2"></tax-phone-input>
  <tax-phone-input [formControl]="phone" [layoutColumns]="2"></tax-phone-input>
  <tax-phone-input [formControl]="phone2" [layoutColumns]="2"></tax-phone-input>

  <tax-input
    [(ngModel)]="nameModel"
    labelText="ngModel - input"
    [descriptionText]="'ngModel - input'"
    [layoutColumns]="2"
    [required]="true"
    [validators]="[isPasswordStrength]"
  ></tax-input>
  <tax-password
    [(ngModel)]="passwordModel"
    labelText="ngModel - password"
    [descriptionText]="'ngModel - password'"
    [layoutColumns]="2"
    [required]="true"
    [validators]="[isPasswordStrength]"
  ></tax-password>

  <tax-password
    [formControl]="password"
    labelText="formControl"
    [descriptionText]="'formControl - password'"
    [layoutColumns]="2"
  ></tax-password>

  <tax-input
    [formControl]="input"
    labelText="formControl"
    [descriptionText]="'formControl - input'"
    [clearable]="true"
    [layoutColumns]="2"
  ></tax-input>

  <form [formGroup]="form">
    <tax-input
      labelText="formGroup - input"
      formControlName="password"
      [clearable]="true"
      [layoutColumns]="2"
    >
    </tax-input>
  </form>

  <tax-input
    [required]="true"
    labelText="user.form.email"
    [(ngModel)]="user.email"
    name="email"
    taxEmailValidator
    [tabindex]="1"
    [layoutColumns]="2"
    [clearable]="true"
    errorText="user.form.incorrect.email"
    errorType="tooltip"
  ></tax-input>

  <tax-phone-input
    [required]="true"
    [id]="'phone'"
    placeholder="login.sms.phone.placeholder"
    [(ngModel)]="user.phone"
    name="phone"
    [clearable]="true"
    [layoutColumns]="2"
    [width]="'50%'"
    [tabindex]="2"
  ></tax-phone-input>

  <tax-input
    [labelText]="'user.form.initials'"
    [id]="'FIO'"
    name="FIO"
    [(ngModel)]="user.name"
    [clearable]="true"
    [layoutColumns]="2"
    [tabindex]="2"
  ></tax-input>

  <tax-input
    [labelText]="'user.form.position'"
    [id]="'position'"
    name="position"
    [(ngModel)]="user.position"
    [clearable]="true"
    [layoutColumns]="2"
    [tabindex]="3"
  ></tax-input>
</div>
